import getMyCSRPrevActionsStore from "../../../../stores/csr-store/csr-prev-actions";
import Et3Button from "../../../../core/et3-button";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";

const MyCSRPrevActionsForm = withLiteObserverAndTheme(() => {
  return (
    <Et3Button
      onClick={async () => await getMyCSRPrevActionsStore().getMyPrevActions()}
      isEnabled={true}
      size="LARGE"
      text="GET"
      type="GET"
    />
  );
});
export default MyCSRPrevActionsForm;
